<template>
  <main-layout
    class="editArgicInfo"
    page-title="编辑农场"
    custom-back
    @listen-back="goBack"
  >
    <div slot="main-content" class="editArgicInfo-content">
      <el-form
        ref="ruleForm"
        size="medium"
        :model="ruleForm"
        :rules="rules"
        label-width="30%"
      >
        <!-- 基本信息 -->
        <BasicInfo
          ref="basicInfo"
          :type="type"
          :allSelectData="allSelectData"
          :baseInfoForm="ruleForm.financeInfoDTO"
          @changeCompanyOneType="changeCompanyOneType"
        ></BasicInfo>

        <!-- 种植信息 -->
        <PlantInfo
          ref="plantInfo"
          :type="type"
          :allSelectData="allSelectData"
          :plantInfoForm="ruleForm.financeInfoDTO"
        ></PlantInfo>

        <!-- 用户信息 -->
        <UserInfo
          ref="userInfo"
          :type="type"
          :allSelectData="allSelectData"
          :userInfoFormArr="ruleForm.userInfoDTOList"
          @add="addForm"
          @delete="deleteForm"
        ></UserInfo>

        <!-- 股东信息 -->
        <ShareholderInfo
          ref="shareholderInfo"
          :type="type"
          :allSelectData="allSelectData"
          :shareholderInfoFormArr="ruleForm.shareholderInfoDTOList"
          @add="addForm"
          @delete="deleteForm"
        ></ShareholderInfo>

        <!-- 客户信息 -->
        <CustomInfo
          ref="customInfo"
          :type="type"
          :allSelectData="allSelectData"
          :customInfoInfoFormArr="ruleForm.customerInfoDTOList"
          @add="addForm"
          @delete="deleteForm"
        ></CustomInfo>

        <!-- 农机作业 -->
        <AgricMachineInfo
          ref="agricMachineInfo"
          :type="type"
          :allSelectData="allSelectData"
          :agricMachineInfoFormArr="ruleForm.machineryInfoDTOList"
          @add="addForm"
          @delete="deleteForm"
        ></AgricMachineInfo>
      </el-form>

      <div class="submit-btn" v-if="type !== 'check'">
        <el-button type="primary" @click="submitForm">保 存</el-button>
      </div>
    </div>
  </main-layout>
</template>

<script>
import MainLayout from "@/layout/MainLayout";
import BasicInfo from "./components/BasicInfo.vue";
import PlantInfo from "./components/PlantInfo.vue";
import UserInfo from "./components/UserInfo.vue";
import ShareholderInfo from "./components/ShareholderInfo.vue";
import CustomInfo from "./components/CustomInfo.vue";
import AgricMachineInfo from "./components/AgricMachineInfo.vue";

import {
  getAllSelectData,
  addFinance,
  getFinanceList,
} from "@/api/request/snkd.produce";
import { getStorage } from "@/utils/storage";

export default {
  name: "EditFarming",
  components: {
    MainLayout,
    BasicInfo,
    PlantInfo,
    UserInfo,
    ShareholderInfo,
    CustomInfo,
    AgricMachineInfo,
  },
  data() {
    return {
      type: "add",
      farmId: 0,
      ruleForm: {
        companyId: 0,
        financeInfoDTO: {
          companyOneType: "01", //默认选中专业合作社
          companyTowType: "",
          memberNum: "",
          boardNum: "",
          premisesType: "",
          workYears: "",
          debtAmount: "",
          companyLevel: "",
          villagePosts: [],
          debtType: "",
          avgAcre: "",
          standardAcre: "",
          avgAcreStatus: null,
          standardAcreStatus: null,
        },
        userInfoDTOList: [],
        shareholderInfoDTOList: [],
        customerInfoDTOList: [],
        machineryInfoDTOList: [],
      },
      rules: {},
      allSelectData: {
        companyTypeArr: [], //企业类型
        companyLevelArr: [], //企业评定级别
        premisesTypeArr: [], //经营场所类型
        villagePostsArr: [], //村内任职
        debtTypeArr: [], //债务类型
        documentTypeArr: [], //证件类型
        educationLevelArr: [], //文化程度
        shareholderDocumentTypeArr: [], //股东证件类型
        toCustomerTypeArr: [], //上游客户类型
        fromCustomerTypeArr: [], //下游客户类型
        saleTypeArr: [], //销售方式
        userTypeArr: [], //用户类型
        //是否为预计
        standardAcreStatusArr: [],
      },
      baseInfoFormStatus: false,
      plantInfoFormStatus: false,
      userInfoFormStatus: false,
      shareholderInfoFormStatus: false,
      customInfoFormStatus: false,
      agricMachineInfoFormStatus: false,
    };
  },
  created() {
    this.type = this.$route.query.type;
    //获取农场id
    const farminfo = getStorage("FARMINFO");
    if (getStorage("FARMINFO")) {
      this.ruleForm.companyId = farminfo.companyId;
      this.farmId = farminfo.farmId;
    }
    this.getSelectData();

    if (this.type === "edit" || this.type === "check") {
      this.getDetail();
    }
  },
  methods: {
    changeCompanyOneType() {
      this.ruleForm.financeInfoDTO.companyTowType = "";
    },
    submitForm() {
      let userInfoStatusArr = [];
      let shareholderInfoStatusArr = [];
      let customerInfoStatusArr = [];
      let machineryInfoStatusArr = [];
      // 基本信息
      this.$refs.basicInfo.$refs.baseInfoForm.validate((valid) => {
        if (valid) {
          this.baseInfoFormStatus = true;
        } else {
          this.baseInfoFormStatus = false;
          console.log("error submit1!!");
        }
      });
      // 种植信息
      this.$refs.plantInfo.$refs.plantInfoForm.validate((valid) => {
        if (valid) {
          this.plantInfoFormStatus = true;
        } else {
          this.plantInfoFormStatus = false;
          console.log("error submit1!!");
        }
      });
      // 用户信息
      this.ruleForm.userInfoDTOList.map((item, index) => {
        this.$refs.userInfo.$refs[`userInfoForm${index}`][0].validate(
          (valid) => {
            if (valid) {
              userInfoStatusArr.push(true);
            } else {
              userInfoStatusArr.push(false);
              console.log("error submit1!!");
            }
          }
        );
      });
      this.userInfoFormStatus = userInfoStatusArr.every(
        (item) => item === true
      );
      // 股东信息
      this.ruleForm.shareholderInfoDTOList.map((item, index) => {
        this.$refs.shareholderInfo.$refs[
          `shareholderInfoForm${index}`
        ][0].validate((valid) => {
          if (valid) {
            shareholderInfoStatusArr.push(true);
          } else {
            shareholderInfoStatusArr.push(false);
            console.log("error submit1!!");
          }
        });
      });
      this.shareholderInfoFormStatus = shareholderInfoStatusArr.every(
        (item) => item === true
      );
      // 客户信息
      this.ruleForm.customerInfoDTOList.map((item, index) => {
        this.$refs.customInfo.$refs[`customInfoForm${index}`][0].validate(
          (valid) => {
            if (valid) {
              customerInfoStatusArr.push(true);
            } else {
              customerInfoStatusArr.push(false);
              console.log("error submit1!!");
            }
          }
        );
      });
      this.customInfoFormStatus = customerInfoStatusArr.every(
        (item) => item === true
      );
      // 农机作业
      this.ruleForm.machineryInfoDTOList.map((item, index) => {
        this.$refs.agricMachineInfo.$refs[
          `agricMachineInfoForm${index}`
        ][0].validate((valid) => {
          if (valid) {
            machineryInfoStatusArr.push(true);
          } else {
            machineryInfoStatusArr.push(false);
            console.log("error submit1!!");
          }
        });
      });
      this.agricMachineInfoFormStatus = machineryInfoStatusArr.every(
        (item) => item === true
      );

      // 必填项检验提示信息
      if (!this.baseInfoFormStatus || !this.plantInfoFormStatus) {
        this.$message({
          message: "当前页面有必填项未完成，请完成后再保存",
          type: "warning",
        });
        return false;
      }
      // 非必填项检验提示信息
      if (
        !this.userInfoFormStatus ||
        !this.shareholderInfoFormStatus ||
        !this.customInfoFormStatus ||
        !this.agricMachineInfoFormStatus
      ) {
        this.$message({
          message: "当前页面有信息校验失败，请修改后再保存",
          type: "warning",
        });
        return false;
      }

      this.$refs.ruleForm.validate((valid) => {
        if (
          valid &&
          this.baseInfoFormStatus &&
          this.plantInfoFormStatus &&
          this.userInfoFormStatus &&
          this.shareholderInfoFormStatus &&
          this.customInfoFormStatus &&
          this.agricMachineInfoFormStatus
        ) {
          this.addFinanceInfo();
          console.log("表单校验成功");
        } else {
          console.log("error submit1!!");
        }
      });
    },
    async addFinanceInfo() {
      //过滤掉没有填值的数据
      let userInfoIndexArr = [];
      let shareholderInfoIndexArr = [];
      let customerInfoIndexArr = [];
      let machineryInfoIndexArr = [];
      this.ruleForm.userInfoDTOList.map((item, index) => {
        let arr = Object.values(item).filter(
          (item) => item !== "" && item !== null
        );
        console.log("arr1", arr);
        if (!arr.length) userInfoIndexArr.push(index);
      });
      userInfoIndexArr.forEach((key) => {
        this.ruleForm.userInfoDTOList.splice(key, 1);
      });

      this.ruleForm.shareholderInfoDTOList.map((item, index) => {
        let arr = Object.values(item).filter(
          (item) => item !== "" && item !== null
        );
        console.log("arr2", arr);
        if (!arr.length) shareholderInfoIndexArr.push(index);
      });
      shareholderInfoIndexArr.forEach((key) => {
        this.ruleForm.shareholderInfoDTOList.splice(key, 1);
      });

      this.ruleForm.customerInfoDTOList.map((item, index) => {
        let arr = Object.values(item).filter(
          (item) => item !== "" && item !== null
        );
        console.log("arr3", arr);
        if (!arr.length) customerInfoIndexArr.push(index);
      });
      customerInfoIndexArr.forEach((key) => {
        this.ruleForm.customerInfoDTOList.splice(key, 1);
      });

      this.ruleForm.machineryInfoDTOList.map((item, index) => {
        let arr = Object.values(item).filter(
          (item) => item !== "" && item !== null
        );
        console.log("arr4", arr);
        if (!arr.length) machineryInfoIndexArr.push(index);
      });
      machineryInfoIndexArr.forEach((key) => {
        this.ruleForm.machineryInfoDTOList.splice(key, 1);
      });

      try {
        await addFinance(this.ruleForm).then((res) => {
          const { respCode } = res;
          if (respCode === 0) {
            this.$message({
              message: "保存成功",
              type: "success",
            });
            window.location.href =
              window.location.origin +
              `/index.html#/home/addfarm/company=${this.ruleForm.companyId}&farm=${this.farmId}&tab=0&source=financeInfo`;
          }
        });
      } catch (e) {
        console.log(e);
      }
    },
    addForm(formName) {
      let obj;
      if (formName === "userInfoDTOList") {
        obj = {
          documentCode: "",
          documentType: "",
          educationLevel: "",
          id: 0,
          jobType: "",
          name: "",
          type: "",
          workYears: "",
        };
      } else if (formName === "shareholderInfoDTOList") {
        obj = {
          bankingRatio: null,
          documentCode: "",
          documentType: "",
          id: 0,
        };
      } else if (formName === "customerInfoDTOList") {
        obj = {
          contractAmount: null,
          customerName: "",
          deadline: "",
          fromCustomerType: "",
          id: 0,
          saleType: "",
          toCustomerType: "",
          year: "",
          yearContractAmount: null,
        };
      } else if (formName === "machineryInfoDTOList") {
        obj = {
          acreage: null,
          costAmount: null,
          id: 0,
          isEstimated: null,
          machineryNum: null,
          peopleNum: null,
          profit: null,
          year: "",
        };
      }
      this.ruleForm[formName].push(obj);
    },
    deleteForm(formName, index) {
      let tips;
      if (formName === "userInfoDTOList") {
        tips = "确认删除当前用户信息？";
      } else if (formName === "shareholderInfoDTOList") {
        tips = "确认删除当前股东信息？";
      } else if (formName === "customerInfoDTOList") {
        tips = "确认删除当前客户信息？";
      } else if (formName === "machineryInfoDTOList") {
        tips = "确认删除当前农机作业？";
      }
      const h = this.$createElement;
      this.$confirm("", {
        confirmButtonText: "确认",
        cancelButtonText: "取消",
        customClass: "confirm-dialog",
        message: h("div", [
          h(
            "p",
            {
              style:
                "font-size: 16px;margin-bottom:12px;color: rgba(0, 0, 0, 0.85);font-weight:400;",
            },
            `提醒`
          ),
          h(
            "p",
            {
              style:
                "font-size: 14px;color: rgba(0, 0, 0, 0.65);font-weight:400;",
            },
            tips
          ),
        ]),
        type: "warning",
      })
        .then(async () => {
          this.ruleForm[formName].splice(index, 1);
          this.$message({
            type: "success",
            message: "删除成功!",
          });
        })
        .catch(() => {});
    },
    async getDetail() {
      try {
        await getFinanceList({
          id: this.ruleForm.companyId,
        }).then((res) => {
          const { respCode, obj } = res;
          if (respCode === 0 && obj) {
            this.ruleForm = {
              ...obj,
              userInfoDTOList: obj.userInfoDTOList.length
                ? obj.userInfoDTOList
                : [],
              shareholderInfoDTOList: obj.shareholderInfoDTOList.length
                ? obj.shareholderInfoDTOList
                : [],
              customerInfoDTOList: obj.customerInfoDTOList.length
                ? obj.customerInfoDTOList
                : [],
              machineryInfoDTOList: obj.machineryInfoDTOList.length
                ? obj.machineryInfoDTOList
                : [],
            };
          }
        });
      } catch (e) {
        console.log(e);
      }
    },
    async getSelectData() {
      try {
        await getAllSelectData().then((res) => {
          const { respCode, obj } = res;
          if (respCode === 0) {
            this.allSelectData = {
              companyTypeArr: obj.companyType, //企业类型
              companyLevelArr: obj.companyLevel, //企业评定级别
              premisesTypeArr: obj.premisesType, //经营场所类型
              villagePostsArr: obj.villagePosts, //村内任职
              debtTypeArr: obj.debtType, //债务类型
              documentTypeArr: obj.documentType, //证件类型
              educationLevelArr: obj.educationLevel, //文化程度
              shareholderDocumentTypeArr: obj.shareholderDocumentType, //股东证件类型
              toCustomerTypeArr: obj.toCustomerType, //上游客户类型
              fromCustomerTypeArr: obj.fromCustomerType, //下游客户类型
              saleTypeArr: obj.saleType, //销售方式
              userTypeArr: obj.userType, //用户类型
              standardAcreStatusArr: [
                {
                  key: 1,
                  value: "是",
                },
                {
                  key: 0,
                  value: "否",
                },
              ],
            };
          }
        });
      } catch (e) {
        console.log(e);
      }
    },
    goBack() {
      window.location.href =
        window.location.origin +
        `/index.html#/home/addfarm/company=${this.ruleForm.companyId}&farm=${this.farmId}&tab=0&source=financeInfo`;
    },
  },
};
</script>

<style scoped lang="scss">
.editArgicInfo {
  .editArgicInfo-content {
    width: 1200px;
    // height: 100%;
    background: #fff;
    margin: 0 auto 40px;
    padding: 60px 68px;
    .submit-btn {
      text-align: center;
      padding-top: 20px;
      .el-button {
        width: 160px;
        height: 38px;
      }
    }
  }
}
</style>

<style lang="scss">
.confirm-dialog .el-message-box__status.el-icon-warning {
  top: 13px !important;
}
.confirm-dialog {
  width: 425px;
}
</style>
